export const urlToExtension = (
  url: string
): 'image' | 'video' | 'audio' | 'unknown' => {
  if (url == null) return 'unknown';
  const extension = url.split('.').pop()?.toLocaleLowerCase();
  if (extension == undefined) return 'unknown';

  if (extension.match(/(jpg|jpeg|png|gif|svg)/)) {
    return 'image';
  }
  if (extension.match(/(mp4|webm|ogg)/)) {
    return 'video';
  }
  if (extension.match(/(mp3|wav|flac)/)) {
    return 'audio';
  }
  return 'unknown';
};
